<template>
  <div>
    <nav
      v-if="!isMobile"
      class="navbar md-down-fixed-top navbar-expand-md navbar-light bg-body pt-4 d-flex flex-column align-items-center"
    >
      <div class="container" style="height: 100%">
        <a class="navbar-brand d-flex flex-row align-items-center" href="/">
          <img
            :src="$store.state.campaign.logo"
            class="d-inline-block align-top"
            :alt="$store.state.campaign.name"
          />
          <span class="mobileHide">{{ $store.state.campaign.name }}</span>
        </a>
        <div class="d-none d-md-flex">
          <ul class="navbar-nav ml-auto d-flex align-items-center">
            <li class="nav-item">
              <a class="nav-link">
                <div
                  v-html="iconLogout"
                  @click="
                    $store.dispatch('logout');
                    $router.push('/');
                  "
                  class="ml-4 f-icon"
                  style="line-height:1px;width:30px;cursor: pointer"
                ></div>
              </a>
            </li>
          </ul>
        </div>
        <div class="d-flex d-md-none">
          <ul class="navbar-nav ml-auto d-flex">
            <a class="nav-item nav-link">
              <i class="fal fa-cog" style="font-size: 1.5rem;"></i>
            </a>
          </ul>
        </div>
      </div>
    </nav>
    <nav
      v-if="!isMobile"
      class="nav nav-pills nav-fill fixed-bottom d-md-none w-100 flex-nowrap"
      id="bottomBar"
    >
      <a class="nav-item nav-link">
        <i class="fal fa-home"></i>
        {{ $t("Home") }}
      </a>
      <a class="nav-item nav-link">
        <i class="fal fa-chart-bar"></i>
        {{ $t("Classifica") }}
      </a>
      <a class="nav-item nav-link">
        <i class="fal fa-tags"></i>
        {{ $t("Catalogo") }}
      </a>
      <a class="nav-item nav-link">
        <i class="fal fa-qrcode"></i>
        {{ $t("Inserisci Codice") }}
      </a>

      <a class="nav-item nav-link">
        <div style="line-height:1px;"></div>
        {{ $t("Invita") }}
      </a>
    </nav>
    <template v-if="!credentialType && !pendingConfirmation">
      <main v-bind:class="isMobile ? '' : 'actions c-complete-profile'">
        <div class="container">
          <form
            data-vv-scope="incompleteProfile"
            @submit.prevent="validateForm('incompleteProfile', updateProfile)"
            style="margin-top: 4rem;"
          >
            <div class="row">
              <div class="col-md-4 offset-md-2">
                <div class="form-group">
                  <input
                    id="first_name"
                    type="text"
                    class="form-control"
                    v-model="first_name"
                    :class="{
                      'is-invalid': errors.has('incompleteProfile.first_name')
                    }"
                    v-validate="'required'"
                    data-vv-as="Name"
                    name="first_name"
                    :placeholder="$t('Nome')"
                  />
                  <label for="first_name" class="h5">
                    {{ "Nome" }}
                  </label>
                  <span
                    v-show="errors.has('incompleteProfile.first_name')"
                    class="invalid-feedback"
                    style="position: relative; bottom: 0px; padding-bottom: 10px;"
                  >
                    <strong>
                      {{ errors.first("incompleteProfile.first_name") }}
                    </strong>
                  </span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <input
                    id="last_name"
                    type="text"
                    class="form-control"
                    v-model="last_name"
                    :class="{
                      'is-invalid': errors.has('incompleteProfile.last_name')
                    }"
                    name="last_name"
                    data-vv-as="Surname"
                    v-validate="'required'"
                    :placeholder="$t('Cognome')"
                  />
                  <label for="last_name" class="h5">
                    {{ "Cognome" }}
                  </label>
                  <span
                    v-show="errors.has('incompleteProfile.last_name')"
                    class="invalid-feedback"
                    style="position: relative; bottom: 0px; padding-bottom: 10px;"
                  >
                    <strong>
                      {{ errors.first("incompleteProfile.last_name") }}
                    </strong>
                  </span>
                </div>
              </div>
              <div class="col-md-8  offset-md-2">
                <div class="form-group">
                  <input
                    id="last_name"
                    type="text"
                    class="form-control"
                    v-model="email"
                    :class="{
                      'is-invalid': errors.has('incompleteProfile.last_name')
                    }"
                    name="email"
                    data-vv-as="E-Mail"
                    v-validate="'required'"
                    :placeholder="$t('E-mail')"
                  />
                  <label for="email" class="h5">
                    {{ $t("E-mail") }}
                  </label>
                  <span
                    v-show="errors.has('incompleteProfile.last_name')"
                    class="invalid-feedback"
                    style="position: relative; bottom: 0px; padding-bottom: 10px;"
                  >
                    <strong>
                      {{ errors.first("incompleteProfile.last_name") }}
                    </strong>
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8 offset-md-2">
                <div class="form-group" v-if="showCredential">
                  <input
                    id="register_credential"
                    type="text"
                    class="form-control"
                    name="register_credential"
                    v-model="credential"
                    value
                    data-vv-as="Email/Mobile"
                    v-validate="'required|phoneOrEmail'"
                    :placeholder="$t('Email / Cellulare')"
                    v-if="$store.state.campaign.idm_phone_login_enabled"
                  />
                  <input
                    id="register_credential"
                    type="text"
                    class="form-control"
                    name="register_credential"
                    v-model="credential"
                    value
                    data-vv-as="Email"
                    v-validate="'required|email'"
                    :placeholder="$t('Email')"
                    v-else
                  />
                  <label
                    for="register_credential"
                    v-if="$store.state.campaign.idm_phone_login_enabled"
                    class="h5"
                    >{{ $t("Email / Cellulare") }}</label
                  >
                  <label for="register_credential" v-else class="h5">
                    {{ $t("Email") }}
                  </label>
                  <span
                    v-show="errors.has('incompleteProfile.register_credential')"
                    class="invalid-feedback"
                    style="position: relative; bottom: 0px; padding-bottom: 10px;"
                  >
                    <strong>
                      {{
                        errors.first("incompleteProfile.register_credential")
                      }}
                    </strong>
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8 offset-md-2">
                <div class="form-check" v-if="showAgreements">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="agreements.tos"
                    name="tos"
                    id="tos"
                    ref="tos"
                    v-validate="'required'"
                  />
                  <label class="form-check-label" for="tos">
                    {{ $t("Ho preso visione, compreso e accetto i") }}
                    <a
                      href="/info/tos"
                      target="_blank"
                      style="text-decoration: underline"
                    >
                      {{ $t("Termini di Servizio") }}
                    </a>
                  </label>
                  <span
                    v-show="errors.has('incompleteProfile.tos')"
                    class="invalid-feedback"
                    style="position: relative; bottom: 0px; padding-bottom: 10px;"
                  >
                    <strong>{{ errors.first("incompleteProfile.tos") }}</strong>
                  </span>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="privacy"
                    id="privacy"
                    ref="privacy"
                    v-model="agreements.privacy"
                    v-validate="'required'"
                  />
                  <label class="form-check-label" for="privacy">
                    {{ $t("Accetto l'informativa sulla ") }}
                    <a
                      target="_blank"
                      href="https://www.iubenda.com/privacy-policy/58441074"
                      style="text-decoration: underline"
                    >
                      {{ $t("Privacy") }}
                    </a>
                    &nbsp;e, avendo preso visione della stessa, autorizzo il
                    Titolare al trattamento dei miei dati personali ad
                    iscrivermi al programma fedeltà Jaked Tribe ed accetto le
                    condizioni generali del programma indicate nel
                    <a
                      style="text-decoration: underline"
                      target="_blank"
                      href="/static/regolamento-loyalty-tribe.pdf"
                      >Regolamento</a
                    >.
                  </label>
                  <span
                    v-show="errors.has('incompleteProfile.privacy')"
                    class="invalid-feedback"
                    style="position: relative; bottom: 0px; padding-bottom: 10px;"
                  >
                    <strong>
                      {{ errors.first("incompleteProfile.privacy") }}
                    </strong>
                  </span>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="marketing"
                    id="marketing"
                    ref="marketing"
                    v-model="agreements.marketing"
                  />
                  <label class="form-check-label" for="marketing">
                    {{
                      $t(
                        "Autorizzo il trattamento dei miei dati personali per finalità di marketing."
                      )
                    }}
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="profilation"
                    ref="profilation"
                    id="profilation"
                    v-model="agreements.profilation"
                    :disabled="!agreements.marketing"
                  />
                  <label class="form-check-label" for="profilation">
                    {{
                      $t(
                        "Autorizzo il trattamento dei miei dati personali per finalità di profilazione."
                      )
                    }}
                  </label>
                </div>
                <div v-if="false" class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="third"
                    id="third"
                    ref="third"
                    v-model="agreements.third"
                  />
                  <label class="form-check-label" for="third">
                    {{
                      $t(
                        "Autorizzo il trattamento dei miei dati personali per finalità di marketing di terze parti."
                      )
                    }}
                  </label>
                </div>
                <div v-if="false" class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="third_profilation"
                    id="third_profilation"
                    ref="third_profilation"
                    v-model="agreements.third_profilation"
                  />
                  <label class="form-check-label" for="third_profilation">
                    {{
                      $t(
                        "Autorizzo il trattamento dei miei dati personali per finalità di profilazione di terze parti."
                      )
                    }}
                  </label>
                </div>

                <div class="form-group col-12 text-center mt-5">
                  <button type="submit" class="btn btn-primary btn-lg">
                    {{ $t("Invia") }}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </main>
    </template>
    <template v-else>
      <div class="container">
        <div class="CTA" style="min-height:0">
          <h2 class="h1 display-4">{{ $t("Verify new account") }}</h2>
          <h5 class="mb-0" v-if="credentialType == 'mobile'">
            {{
              $t(
                "Ti abbiamo inviato un SMS con il codice per la verifica del numero"
              )
            }}
            <br />
            <strong x-ms-format-detection="none">
              {{ confirmationAddress }}
            </strong>
          </h5>
          <h5 class="mb-0" v-else>
            {{
              $t(
                "Ti abbiamo inviato una email con il codice per la verifica dell'indirizzo"
              )
            }}
            <br />
            <strong x-ms-format-detection="none">
              {{ confirmationAddress }}
            </strong>
          </h5>
        </div>
        <form
          class="mt-5 row"
          style="padding-left:15px;padding-right:15px;"
          data-vv-scope="confirmationForm"
          @submit.prevent="validateForm('confirmationForm', verify)"
          v-cloak
        >
          <div class="form-group col-12">
            <input
              id="confirmation"
              type="text"
              class="form-control $errors->has('confirmation') ? ' is-invalid' : '' }}"
              name="confirmation"
              required
              :placeholder="$t('Codice di conferma')"
              v-validate="'required'"
              v-model="confirmationCode"
              maxlength="5"
            />
            <label for="confirmation" class="h5">
              {{ $t("Codice di conferma") }}
            </label>
          </div>
          <div
            class="row"
            style="width:100%"
            :style="{
              'margin-top': $mq !== 'sm' && $mq !== 'md' ? '89px' : '0'
            }"
          >
            <div
              class="col-12 col-lg-6 text-center text-lg-left"
              style="line-height:48px"
            >
              <small>{{ $t("Non hai ricevuto il codice?") }}</small>
              <a
                class="c-form-actions__link btn-not-spinner"
                href="#"
                @click="resendVerifyCode"
                >{{ $t("Reinvia") }}</a
              >
            </div>
            <div
              class="form-group col-12 col-lg-6 text-center text-lg-right"
              style="padding-top: 0"
            >
              <button class="btn btn-primary btn-lg">
                {{ $t("Conferma") }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </template>
  </div>
</template>
<script>
import _ from "lodash";
import iconLogout from "./../assets/svg/fnz_logout.svg";

export default {
  name: "complete-profile",
  data() {
    return {
      confirmationCode: null,
      first_name: null,
      last_name: null,
      email: null,
      credential: null,
      credentialType: null,
      confirmationAddress: null,
      agreements: {
        tos: false,
        privacy: false,
        marketing: false,
        profilation: false,
        third: false,
        third_profilation: false
      },
      isMobile: this.$route.query.mobile === "true",
      iconLogout: iconLogout
    };
  },
  created() {
    this.$store.commit("showSpinner");
    this.$http.get("/api/v1/external/users/info").then(res => {
      if (res.data.data.first_name !== undefined) {
        this.first_name = res.data.data.first_name;
      }

      if (res.data.data.last_name !== undefined) {
        this.last_name = res.data.data.last_name;
      }

      this.email = res.data.data.email.email;
      this.$store.commit("hideSpinner");
    });

    if (this.pendingConfirmation) {
      this.confirmationAddress = this.pendingConfirmation.address;
      this.credentialType = this.pendingConfirmation.type;
    }
  },
  computed: {
    pendingConfirmation() {
      return this.$store.getters.getPendingConfirmation;
    },
    missingFields() {
      return this.$store.getters.getMissingProfileFields;
    },
    showCredential() {
      return _.find(this.missingFields, ["id", "email"]);
    },
    showProfiling() {
      return _.find(this.missingFields, ["id", "first_name"]);
    },
    showAgreements() {
      return true;
    }
  },
  methods: {
    async updateProfile() {
      this.$store.commit("showSpinner");
      try {
        if (this.first_name && this.last_name) {
          await this.$http.post(
            "api/v1/campaigns/" +
              this.$store.state.campaign.id +
              "/users/profile/info",
            {
              first_name: this.first_name,
              last_name: this.last_name,
              email: this.email
            }
          );
        }

        if (this.agreements.tos && this.agreements.privacy) {
          await this.$http.patch(
            "api/v1/campaigns/" +
              this.$store.state.campaign.id +
              "/users/agreements",
            this.agreements
          );
        }

        if (this.credential) {
          const responseCredential = await this.$http.post(
            "api/v1/campaigns/" +
              this.$store.state.campaign.id +
              "/users/profile/credentials",
            {
              credential: this.credential
            }
          );
          this.credentialType = responseCredential.data.data.credential_type;
          this.confirmationAddress =
            responseCredential.data.data.credential_address;
        }
      } catch (err) {
        console.log(err);
      }

      if (!this.pendingConfirmation) {
        this.$store.state.unavailableUserState = false;
        this.$http.post(
          "api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/profile/attributes",
          {
            first_name: this.first_name,
            last_name: this.last_name
          }
        );
        if (this.$route.query.mobile === "true") {
          window.location.replace(
            `dashboard?mobile=true&access_token=${
              this.$store.state.authorization.access_token
            }`
          );
          //this.$router.push({
          //  name: "dashboard",
          //  query: {
          //    mobile: true,
          //    access_token: this.$store.state.authorization.access_token
          //  }
          //});
          return;
        }
        this.$router.replace("/dashboard");
      }
      this.$store.commit("hideSpinner");
    },
    async verify() {
      this.$store.commit("showSpinner");

      try {
        await this.$http.post(
          "api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/profile/credentials/verify",
          {
            credential: this.confirmationAddress,
            credential_type: this.credentialType,
            verify_code: this.confirmationCode
          }
        );
        await this.$store.dispatch("getUserInfo").then(() => {
          this.$store.state.unavailableUserState = false;
          this.$router.push("/dashboard");
        });
      } catch (err) {
        let errorStatus = _.get(err, "response.status");
        if (errorStatus === 404) {
          this.$store.commit("pushMessage", {
            type: "error",
            title: "Error",
            text: "Invalid code"
          });
        } else {
          this.$store.commit("pushMessage", {
            type: "error",
            title: "Error",
            text: "An error occurred"
          });
        }
      }

      this.$store.commit("hideSpinner");
    },
    async resendVerifyCode() {
      this.$store.commit("showSpinner");
      if (this.credentialType === "email") {
        await this.$http.post(
          "api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/email/resendVerify",
          {
            email: this.confirmationAddress
          }
        );
      } else {
        this.$http.post(
          "api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/mobile/resendVerify",
          {
            mobile: this.confirmationAddress
          }
        );
      }

      this.$store.commit("hideSpinner");
    }
  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    iconLogout: iconLogout
  }
};
</script>
<style scoped>
@media (max-width: 991.98px) {
  .c-complete-profile {
    margin-top: 250px;
  }
}
</style>
